import { render, staticRenderFns } from "./my_recognitions_tab.vue?vue&type=template&id=db173b0e"
import script from "./my_recognitions_tab.vue?vue&type=script&lang=js"
export * from "./my_recognitions_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports